export const iconFontAwesomeFoodBeverageBreadSlice = (
	<i className="fa-solid fa-bread-slice"></i>
);
